
export const routePatterns: string[] = [
    '/:lang([a-z]{2}-[A-Z]{2})/:sitecoreRoute*',
    '/:lang([a-z]{2})/:sitecoreRoute*',
    '/:sitecoreRoute*',
];